import { FieldMappingRow } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/MappingConfiguration/FieldMappingRow";
import { Divider, Flex, Text } from "@theorgchartdev/storybook";
import SectionCard from "@/appComponents/Blocks/Composites/SectionCard/SectionCard";
import { appstr } from "@coreapp/utils/appstr";
import {
  GetCostPositionEmployeeFieldGroups,
  GetRequiredFields,
  initializeFieldFormats
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/MappingConfiguration/Utils";
import { CostBandConfiguration } from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/MappingConfiguration/CostBandConfiguration";
import { useEffect } from "react";
import {
  SYSTEM_CALCULATE,
  kPositionBudgetedSalary,
  kSalaryRollup,
  kCurrentPositionCost,
  kPositionBudgetRollup
} from "@coreapp/constants";

export const BudgetMappingSection = ({
  localConfig,
  BuildFieldMappingOptions,
  disableDropdowns,
  handleFieldRename,
  handleCustomFieldNameValidation,
  onUpdate
}) => {
  const requiredFields = GetRequiredFields(localConfig);
  const costFieldGroups = GetCostPositionEmployeeFieldGroups();
  const { posFieldGroup, empFieldGroup } = costFieldGroups || {
    posFieldGroup: {},
    empFieldGroup: {}
  };

  // Initialize currency formatting for budget fields
  useEffect(() => {
    if (onUpdate && (posFieldGroup || empFieldGroup) && localConfig.fields) {
      const currencyFields = [];

      // Get mapped names for position fields (Position Budgeted Salary can be system calculated)
      if (posFieldGroup) {
        Object.keys(posFieldGroup).forEach(fieldId => {
          const mappedName = localConfig.fields[fieldId];
          if (mappedName && mappedName !== SYSTEM_CALCULATE && mappedName !== "") {
            currencyFields.push(mappedName);
          } else {
            currencyFields.push(fieldId);
          }
        });
      }

      if (empFieldGroup) {
        Object.keys(empFieldGroup).forEach(fieldId => {
          const mappedName = localConfig.fields[fieldId];
          if (mappedName) {
            currencyFields.push(mappedName);
          }
        });
      }

      currencyFields.push(kSalaryRollup);
      currencyFields.push(kCurrentPositionCost);
      currencyFields.push(kPositionBudgetRollup);

      if (currencyFields.length > 0) {
        initializeFieldFormats(currencyFields, localConfig, onUpdate, "currency");
      }
    }
  }, [localConfig]);

  return (
    <SectionCard title={appstr("Budget field mapping")}>
      <Flex direction={"column"} gap={"24px"}>
        <Flex direction={"column"} gap={"16px"}>
          <Text size="medium" modifier={"bold"}>
            {appstr("Employee fields")}
          </Text>
          {empFieldGroup &&
            Object.keys(empFieldGroup).map(key => (
              <FieldMappingRow
                key={key}
                fieldKey={key}
                fieldValue={localConfig.fields ? localConfig.fields[key] : null}
                localConfig={localConfig}
                BuildFieldMappingOptions={BuildFieldMappingOptions}
                disabled={disableDropdowns}
                handleFieldRename={handleFieldRename}
                handleCustomFieldNameValidation={handleCustomFieldNameValidation}
                required={
                  requiredFields &&
                  (Array.isArray(requiredFields)
                    ? requiredFields.includes(key)
                    : Object.keys(requiredFields).includes(key))
                }
              />
            ))}
        </Flex>
        <Divider />
        <Flex direction={"column"} gap={"16px"}>
          <Text size="medium" modifier={"bold"}>
            {appstr("Position fields")}
          </Text>
          {posFieldGroup && (
            <Flex direction={"column"} gap={"16px"}>
              <CostBandConfiguration
                localConfig={localConfig}
                BuildFieldMappingOptions={BuildFieldMappingOptions}
                disableDropdowns={disableDropdowns}
                handleFieldRename={handleFieldRename}
                handleCustomFieldNameValidation={handleCustomFieldNameValidation}
                onUpdate={onUpdate}
              />
              {Object.keys(posFieldGroup).map(key => (
                <FieldMappingRow
                  key={key}
                  fieldKey={key}
                  fieldValue={localConfig.fields ? localConfig.fields[key] : null}
                  localConfig={localConfig}
                  BuildFieldMappingOptions={BuildFieldMappingOptions}
                  disabled={disableDropdowns}
                  handleFieldRename={handleFieldRename}
                  handleCustomFieldNameValidation={handleCustomFieldNameValidation}
                  required={
                    requiredFields &&
                    (Array.isArray(requiredFields)
                      ? requiredFields.includes(key)
                      : Object.keys(requiredFields).includes(key))
                  }
                  infoMessage={
                    key === kPositionBudgetedSalary ? appstr("Position budget help") : undefined
                  }
                  onUpdate={onUpdate}
                />
              ))}
            </Flex>
          )}
        </Flex>
        <Divider />
      </Flex>
    </SectionCard>
  );
};
